export default {
  title: 'Pakettitoimitusten määritys',
  form: {
    title: 'Luo toimitus',
    companies: {
      label: 'Yritykset',
    },
  },
  table: {
    title: 'Toimitushistoria',
    fields: {
      name: 'Yritys',
      fulfilled: 'Toimitettu',
    },
  },
  buttons: {
    create_fulfillment: 'Luo toimitus',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_create_fulfillment: 'Toimituksen luominen epäonnistui',
  },
};
